import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/_auth/allocation/_layout/settings/")({
  beforeLoad: () => {
    throw redirect({ to: "/allocation/settings/$subTab", params: { subTab: "coverage" } })
  },
})
